<template>
    <div class="AboutUs">
        <nav-igation class="nav white"></nav-igation>
        <div class="banner" :style="{ backgroundImage: `url(${device == 'm' ? require('../../image/m-banner4.jpg') : require('../../image/banner4.jpg')})` }">
            <h3> China cloud industrial zone </h3>
            <p>关于中云工业园</p>
        </div>
        <div class="content">
            <img src="@/image/t10.jpg" alt="">
            <div class="info">
                <div class="title">
                    <h3>关于中云工业园介绍</h3>
                    <p> About Zhongyun Industrial Park </p>
                </div>
                <p>北京小招云有限公司，是一家主要从事空地规划招商、土地调规盘活、闲置资产处置、园区运营管理的重资产市场化招商引资服务商，是“中云工业园”项目的具体执行单位。公司由香港中云有限公司投资运营。 北京小招云有限公司打造的“中云工业园”品牌，专注于为地区规划高质量工业园区，并进行优质重资产招商引资建设，促进地方产业链提质升级，助力实体经济高质量发展。
                </p>
                <img src="@/image/bjkl.jpg" alt="">
            </div>
        </div>
        <div>
            <Footer></Footer>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            device: '',
            imgRou: '',//图片引入端 默认pc 
        }
    },
    mounted() {
        var vw = window.screen.width
        if (vw <= 1224) {
            this.device = 'ipad'
            this.imgRou = 'i-'
        }
        if (vw <= 750) {
            this.device = 'm'
            this.imgRou = 'm-'
        }
    },
}
</script>
<style lang="scss" scoped>
.nav {
    position: fixed;
    left: 0;
    top: 0;
    background: #fff;
}

.content {
    display: flex;
    margin: 120px 18%;

    >img {
        width: 30%;
    }

    .info {
        margin-left: 81px;

        img {
            width: 100%;
            margin-top: 42px;
            position: relative;
            // left: -30px;
        }

        >p {
            font-size: 20px;
            line-height: 30px;
            color: #303133;
            margin-top: 80px;
        }

        .title {
            border-left: 2px solid #2EA7E0;
            padding-left: 30px;

            h3 {
                font-size: 30px;
                color: #303133;
                font-weight: 600;
            }

            p {
                font-size: 22px;
                color: #303133;
                margin-top: 20px;
            }
        }
    }
}

.banner {
    width: 100%;
    height: 500px;
    background-image: url(../../image/banner4.jpg);
    background-size: 100% 100%;
    display: flex;
    margin-top: 80px;
    flex-direction: column;

    h3,
    div,
    p {
        margin: 0 auto;
        width: 52%;
        text-align: center;
    }

    h3 {
        font-size: 40px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
        margin-top: 150px
    }

    div {}

    p {
        font-size: 72px;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 94px;
        letter-spacing: 4px;
        margin-top: 18px;
    }
}</style>


// WEBPACK FOOTER //
// src/pages/AboutUs/index.vue